/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
export const SUSPENDED_CHECK_TAB_DATA = 'SUSPENDED_CHECK_TAB_DATA';
export const HANDLE_ERROR_MESSAGE_FOR_SUP_CHECK = 'HANDLE_ERROR_MESSAGE_FOR_SUP_CHECK';
export const GET_SUSPENDED_CHECK_LOG_GRID_LIST = 'GET_SUSPENDED_CHECK_LOG_GRID_LIST';
export const GET_INVOICE_GRID_LIST = 'GET_INVOICE_GRID_LIST';
export const GET_RECONCILIATION_GRID_LIST = 'GET_RECONCILIATION_GRID_LIST';
export const SAVE_OR_UPDATE_SUSPENDED_CHECKS = 'SAVE_OR_UPDATE_SUSPENDED_CHECKS';
export const FETCH_CREDIT_BALANCE_COUNT = 'FETCH_CREDIT_BALANCE_COUNT';
export const FETCH_UNALLOCATED_BALANCE = 'FETCH_UNALLOCATED_BALANCE';

